export const SET_ERROR_LOG = 'SET_ERROR_LOG';
export const REQUEST_FAIL = 'REQUEST_FAIL';